<template>
  <validation-observer ref="form" v-if="item" v-slot="{ passes, invalid }">
      <div>
          <div class="w-full">
              <slot name="message" />
              <slot :form="item" :invalid="invalid" />
              <slot name="after" :form="item" :invalid="invalid" />
              <slot name="debug" :form="item" :invalid="invalid" />
          </div>
          <div class="flex w-full">
              <slot name="publisher" :form="item" :invalid="invalid" />
              <bc-button variant="primary" :disabled="invalid" @click="passes(Update)">
                Save
              </bc-button>
          </div>
      </div>
  </validation-observer>
</template>
<script>
export default {
    props: {
        scope: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        back: {
          type: String,
          required: false
        }
    },
    data() {
        return {
          item: false,
          loading: false
        }
    },
    created() {
        this.getCollection()
    },
    methods: {
        getCollection() {
            this.loading = true
            axios.get(this.url)
                .then((response) => {
                    this.item = response.data
                }).catch((error) => {
                    console.log(error)
                }).then(() => {
                    this.loading = false
                })
        },
        Update() {
            this.loading = true
            axios({
                    method: 'PUT',
                    url: this.url,
                    data: this.item
                })
                .then((response) => {
                    this.$notify({
                        title: 'Updated',
                        message: response.data.message,
                        progressBar: true
                    })

                    if(this.back) {
                      this.$nextTick(() => {
                        window.location = this.back
                      });
                    }
                })
                .catch((err) => {
                    this.$notify({
                        title: 'Error',
                        message: err.response.data.message,
                        progressBar: true
                    })
                })
                .then(() => {
                    this.loading = false
                    this.changed = false
                })
        }
    }
}
</script>
